// src/components/Icon.tsx
import React, { Suspense } from "react";
import { IconBaseProps } from "react-icons";
import useThemeValue from "src/Modules/ThemeModule/Hooks/useThemeValue";
import { VARIANT } from "src/Modules/ThemeModule/Types/CommonTypes";
import Block, { BlockProps } from "./Block";
import * as IconMap from "./generated-icons"; // Generated file with icon imports

type IconProps = {
  name: string;
  size?: number | string;
  color?: string;
  dark?: boolean;
  iconVariant?: VARIANT;
  className?: string;
  style?: React.CSSProperties;
} & IconBaseProps &
  React.HTMLAttributes<HTMLSpanElement> &
  BlockProps;

function Icon(props: IconProps) {
  const theme = useThemeValue();

  const {
    name,
    size = 24,
    color,
    dark = theme.type === "dark",
    iconVariant = dark ? "white" : "black",
    className,
    style,
    ...restProps
  } = props;

  const IconComponent = IconMap[name as keyof typeof IconMap];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in the generated icon map.`);
    return null; // Or a fallback icon
  }

  const iconColor = color ? color : theme.colors[iconVariant];

  return (
    <Block {...restProps}>
      <Suspense fallback={<div>Loading...</div>}>
        <IconComponent
          className={className}
          size={size}
          color={iconColor}
          style={style}
          {...restProps}
        />
      </Suspense>
    </Block>
  );
}

export default Icon;
